import { CustomNode } from '../../../types';
import { sendInAppIcon } from '../../../icons';

const DEFAULT_ICON = sendInAppIcon;

export const sendInAppConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
